var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-autocomplete", {
    ref: "cityInput",
    staticClass: "inline-input",
    style: _vm.width,
    attrs: {
      slot: "reference",
      "fetch-suggestions": _vm.querySearch,
      "trigger-on-focus": false,
      placeholder:
        _vm.placeholderText == ""
          ? "请输入" + (this.searchType == 1 ? "城市" : "国家") + "名称"
          : _vm.placeholderText,
      "value-key": "value",
      size: _vm.sizeType,
    },
    on: {
      select: function ($event) {
        return _vm.handleSelect($event, _vm.obj)
      },
      input: _vm.inputValue,
    },
    slot: "reference",
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ item }) {
          return [
            _c("div", { staticClass: "name" }, [
              _vm._v(
                _vm._s(item.cityNameCn) + "(" + _vm._s(item.countryNameCn) + ")"
              ),
            ]),
          ]
        },
      },
    ]),
    model: {
      value: _vm.obj[_vm.nameProName],
      callback: function ($$v) {
        _vm.$set(_vm.obj, _vm.nameProName, $$v)
      },
      expression: "obj[nameProName]",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }